import { globalAxios } from "@/axios-path.js";
//fetchSaleMessengerReport
export default {
  namespaced: true,
  state: {
    config_path: {
      order_status: 6,
      datetime_start: null,
      datetime_end: null,
      district_id: [0],
    },
    clone_config_path: {
      order_status: 6,
      datetime_start: null,
      datetime_end: null,
      district_id: [0],
    },
    sale_messenger_list: [],
    sale_messenger_summary: {},
    export_messegner_format: [],
  },
  mutations: {
    resetState(state) {
      state.config_path = {
        order_status: 6,
        datetime_start: null,
        datetime_end: null,
        district_id: [0],
      };
      state.clone_config_path = {
        order_status: 6,
        datetime_start: null,
        datetime_end: null,
        district_id: [0],
      };
      state.sale_messenger_list = [];
      state.sale_messenger_summary = {};
      state.export_messegner_format = [];
    },
    cloneConfigPath(state) {
      state.clone_config_path = JSON.parse(JSON.stringify(state.config_path));
    },
    getReportSummary(state, data) {
      state.sale_messenger_summary = data;
    },
    fetchReportList(state, data) {
      state.sale_messenger_list = data;
      let count_no = 1;
      for (let val of state.sale_messenger_list) {
        val.no = count_no++;
        val.no_default = count_no - 1;
      }
    },
    getExportReportForm(state) {
      state.export_messegner_format = [];
      for (let val of state.sale_messenger_list) {
        let index = state.sale_messenger_list.indexOf(val);
        let push_data = {
          No: index + 1,
          order_code: val.order_code,
          rider: val.rider_name,
          add_on: val.addon
            ? parseFloat(val.addon)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00",
          transport: val.transport
            ? parseFloat(val.transport)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00",
          extra_time: val.extra_time
            ? parseFloat(val.extra_time)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00",
          promotion: val.promotion
            ? parseFloat(val.promotion)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00",
          revenue: val.summary
            ? parseFloat(val.summary)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0.00",
        };
        state.export_messegner_format.push(push_data);
      }
    },
    getExportSummary(state) {
      let push_data_2 = {
        order_code: "Total",
        add_on: state.sale_messenger_summary.addon
          ? parseFloat(state.sale_messenger_summary.addon)
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          : "0.00",
        transport: state.sale_messenger_summary.transport
          ? parseFloat(state.sale_messenger_summary.transport)
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          : "0.00",
        extra_time: state.sale_messenger_summary.extra_time
          ? parseFloat(state.sale_messenger_summary.extra_time)
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          : "0.00",
        promotion: state.sale_messenger_summary.promotion
          ? parseFloat(state.sale_messenger_summary.promotion)
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          : "0.00",
        revenue: state.sale_messenger_summary.summary
          ? parseFloat(state.sale_messenger_summary.summary)
              .toFixed(2)
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          : "0.00",
      };
      state.export_messegner_format.push(push_data_2);
    },
  },
  actions: {
    async fetchReportList({ commit, rootState, dispatch }, config_path) {
      let url =
        rootState.api_urls.fetchSaleMessengerReport_fetchReportList +
        config_path.order_status +
        "/" +
        config_path.datetime_start +
        "/" +
        config_path.datetime_end;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return [];
      } else {
        commit("cloneConfigPath");
        commit("fetchReportList", res.order);
        commit("getReportSummary", res.calculate);
        commit("getExportReportForm");
        commit("getExportSummary");
      }
    },
    fetchReportByDistrict({ rootState, state, dispatch, commit }) {
      let url = `/api/v1/${
        rootState.backOffice.province
      }/search_by_district/sale_store_report_messenger/order_status/datetime_start/datetime_end/${
        state.config_path.order_status
      }/${state.config_path.datetime_start}/${state.config_path.datetime_end}`;

      let payload = {
        district: state.config_path.district_id,
      };
      return globalAxios
        .post(url, payload)
        .then((res) => {
          commit("cloneConfigPath");
          commit("fetchReportList", res.order);
          commit("getReportSummary", res.calculate);
          commit("getExportReportForm");
          commit("getExportSummary");
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
  },
  getters: {},
};
